export enum StopActionsEnum {
    FINISH = 'finish',
    CONTINUE = 'continue',
}
